import { render, staticRenderFns } from "./TraitTable.vue?vue&type=template&id=09ed4586&"
import script from "./TraitTable.vue?vue&type=script&lang=js&"
export * from "./TraitTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports